import React, { useRef } from 'react';

/*
    Our site is loaded into an iframe on the labxchange platform, when a focus lock is used manually or in a modal
    the focus will be trapped inside the iframe and won't allow users to tab to other items on the labxchange webpage
    the focus manager keeps track of a user's tabbing behaviour and sends a message to the platform so that it can be 
    aware of when to size back focus. 
*/
export default function IFrameFocusManager(props) {
    const focusBreak = useRef();
    
    function manageFocus(event){
        //detects when the user tabs to the injected div and breaks focus.
        if(event.target === focusBreak.current){
            event.preventDefault();
            event.target.blur(); 

            //send message to platform
            window?.parent.postMessage({
                method: 'event',
                data: {type: 'returnFocusToPlatform'}
            }, '*');
        }
    }

    return (
        <div
        tabIndex={0}
        role='button' 
        onKeyDown={
            (e) => {
                if(e.key === 'Tab'){
                    manageFocus(e, props.children, props.parentRef) 
                } 
            }
        }>
            {props.children}
            {/* inserts a div at the end of the tab order */}
            <div ref={focusBreak}></div>
        </div>
    );
}
